import { Icon } from "@msuite/ui/icons";
import { getArticleGroupNumberString } from "@msuite/utils/stock";

/** Props Interface */
interface ArticleGroupTableHeaderProps {
	articleGroupNumber: number;
	articleGroupName: string;
}

export function ArticleGroupTableHeader({
	articleGroupNumber,
	articleGroupName,
}: ArticleGroupTableHeaderProps) {
	return (
		<div className="flex flex-row *:tabular-nums items-center gap-2">
			<p>{getArticleGroupNumberString(articleGroupNumber)}</p>
			<Icon
				name="ChevronRight"
				size={8}
			/>
			<p>{articleGroupName}</p>
		</div>
	);
}
